import React from 'react';
import Reveal from '../Reveal';
import { scrollToId } from '../Navbar';

// Seventy.blue-style alternating feature split:
//   left: small eyebrow, big lowercase serif title, description, italic "Discover More" link
//   right: cinematic image with coord tag top-right and hash-label bottom-left overlay
export default function FeatureSplit({
  id,
  label,
  title,
  description,
  image,
  coord,
  reverse = false,
  linkText = 'Discover More',
  linkTarget = 'contact',
}) {
  const onDiscover = () => {
    try {
      sessionStorage.setItem('rb_selected_interest', label);
    } catch (e) {
      // noop
    }
    scrollToId(linkTarget);
  };

  return (
    <section
      id={id}
      className="relative bg-[#f4f1eb] py-24 md:py-36"
    >
      <div
        className={`flex flex-col ${
          reverse ? 'md:flex-row-reverse' : 'md:flex-row'
        } items-stretch gap-14 md:gap-0`}
      >
        {/* Text column */}
        <div className="md:w-1/2 flex items-center px-6 md:px-16 lg:px-24">
          <Reveal className="max-w-md">
            <div className="font-sans-ui text-[10px] tracking-[0.3em] text-[#5a5852] mb-7">
              {label}
            </div>
            <h2 className="font-serif-display text-[46px] md:text-[64px] lg:text-[76px] leading-[1] tracking-wide lowercase text-[#2b2a27]">
              {title}
            </h2>
            <p className="mt-9 text-[14px] md:text-[15px] leading-[1.9] text-[#5a5852]">
              {description}
            </p>
            <button
              onClick={onDiscover}
              className="mt-10 font-serif-display italic text-[17px] text-[#2b2a27] underline-anim pb-1"
            >
              {linkText}
            </button>
          </Reveal>
        </div>

        {/* Image column */}
        <div className="md:w-1/2 relative image-zoom overflow-hidden">
          <div className="aspect-[4/5] md:aspect-auto md:h-[680px] overflow-hidden">
            <img
              src={image}
              alt={label}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          {coord && (
            <div className="absolute top-6 right-6 md:top-10 md:right-10 font-sans-ui text-[10px] text-white/90 tracking-[0.2em]">
              {coord}
            </div>
          )}
          <div className="absolute bottom-6 left-6 md:bottom-10 md:left-10 pointer-events-none">
            <div className="font-serif-display text-white text-[28px] md:text-[40px] lowercase leading-none drop-shadow-sm">
              # {title}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
